module.exports = __webpack_public_path__ + "static/historical-performance-8ae237b33c3b54d07019a8f3dc40534d.png";